import type { FunctionalComponent } from 'vue'

export const GoogleAuthIcon: FunctionalComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path d="M23.457 23.9766L23.457 7.02344L9.00098 7.02344L9.00098 28.9766L18.457 28.9766C21.2185 28.9766 23.457 26.738 23.457 23.9766Z" fill="var(--colors-text-base)" />
      <path d="M11.0781 9.0625H21.4307V23.9463C21.4307 25.6031 20.0875 26.9463 18.4307 26.9463H11.0781V9.0625Z" fill="var(--colors-bg-base)" />
      <rect x="11.8125" y="8.11719" width="4.83496" height="1.9209" rx="0.960449" fill="var(--colors-text-base)" />
      <path
        d="M27.3857 13.7578C27.938 13.7578 28.3857 14.2055 28.3857 14.7578V21.2412C28.3857 21.7935 27.938 22.2412 27.3857 22.2412H16.0615C15.5092 22.2412 15.0615 21.7935 15.0615 21.2412V19.8506L13.2109 18L15.0615 16.1494V14.7578C15.0615 14.2055 15.5092 13.7578 16.0615 13.7578H27.3857Z"
        fill="var(--colors-primary)"
      />
      <circle cx="19.2544" cy="17.9966" r="1.25439" fill="var(--colors-bg-base)" />
      <circle cx="24.1255" cy="17.9966" r="1.25439" fill="var(--colors-bg-base)" />
    </svg>
  )
}
